<template>
    <jet-dialog-modal ref="modal" :show="show_modal" maxWidth="lg" @close="show_modal = false">
        <template v-slot:title>
            <div class="flex text-gray-700 text-base font-semibold">
                <span>Generate Request Link</span>
                <vue-feather type="link-2" class="h-5 w-5 ml-2 self-center"></vue-feather>
            </div>
        </template>
        <template v-slot:content>

            <div class="text-gray-600 text-sm">
                Add an email to associate the recording with a specific user.
            </div>

            <div class="text-gray-600 flex items-center gap-x-4 mt-3">
                <jet-label for="email" value="User email" class="text-sm flex-shrink-0" />
                <jet-input id="email" type="email" ref="email" class="mt-1 mr-6 block flex-1 text-sm" v-model="email"
                    placeholder="john@doe.com (optional)" />
            </div>
        </template>
        <template v-slot:footer>
            <div class="flex w-full flex-row justify-between">
                <div class="flex w-full">
                    <jet-button class="w-full place-content-center" v-clipboard:copy="baseurl"
                        v-clipboard:success="confirmCopy" v-clipboard:error="errorCopy" :disabled="!emailValidOrEmpty">
                        Copy Link
                    </jet-button>
                </div>
            </div>
        </template>
    </jet-dialog-modal>
</template>

<script>

import JetDialogModal from '@/Jetstream/DialogModal'
import JetButton from '@/Jetstream/Button'
import JetInput from '@/Jetstream/Input'
import JetLabel from '@/Jetstream/Label'

export default {

    props: [''],

    components: {
        JetDialogModal, JetButton, JetInput, JetLabel
    },

    data() {
        return {
            show_modal: false,
            app_url: this.$page.props.app_url,
            userid: this.$page.props.user.id,
            slugname: this.$page.props.user.current_team.slugname,
            baseurl: this.$page.props.app_url + "/recorder?team=" + this.$page.props.user.current_team.slugname + "&rl=",
            custom_url: this.$page.props.app_url + "/recorder",
            email: '',
            data: { o: this.$page.props.user.id },
            copied: false,
            emailValidOrEmpty: true,
            notifyme: true,
            app_name: this.$page.props.app_name
        }
    },

    created: function () {
        //this.get_meta();
        if (this.$page.props.app_env == "production") {
            let domain = this.$page.props.app_url.split('.').slice(-2).join('.')
            this.custom_url = this.custom_url.replace(this.$page.props.app_url, "https://" + this.slugname + "." + domain) + "?rl=";
        } else {
            this.custom_url = this.custom_url + "?team=" + this.slugname + "&rl=";
        }
        this.baseurl = this.custom_url + btoa(JSON.stringify(this.data));
        //console.log("A")
    },


    methods: {
        open: function () {
            this.show_modal = true
            setTimeout(function () {
                this.$refs.email.focus()
            }.bind(this), 300)
        },
        close: function () {
            this.show_modal = false
        },
        onSuccessCopy: function () {
            console.log("onSuccessCopy")
        },
        onErrorCopy: function () {
            console.log("onErrorCopy")
        },
        confirmCopy: function () {
            // let timeout_message = setTimeout(function() {
            //     this.copied = false;
            // }.bind(this), 3000);
            let options = {
                type: "default",
                timeout: 6000,
                position: "top-right",
                //transition: "slide",
                //toastBackgroundColor: "#FFFFFF",
                hideProgressBar: false,
            }
            this.$moshaToast("Link copied in your clipboard!", options)
            this.close()
        },
        errorCopy: function () {
            // let timeout_message = setTimeout(function() {
            //     this.copied = false;
            // }.bind(this), 3000);
            let options = {
                type: "danger",
                timeout: -1,
                position: "top-right",
                //transition: "slide",
                //toastBackgroundColor: "#FFFFFF",
                //hideProgressBar: false,
            }
            this.$moshaToast("A browser error occured, link not copied", options)
            this.close()
        },

        //         copy: function() {
        //             let container = this.$refs.container
        //             this.$copyText(this.baseurl, container)
        //
        //             this.copied = true;
        //
        //             let timeout_message = setTimeout(function() {
        //                 this.copied = false;
        //             }.bind(this), 3000);
        //         },

        validateEmail: function (email) {
            var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        validateNotempty: function (value) {
            var re = /^\s*\S+.*/;
            return re.test(value);
        },
        changeNotify: function (event) {
            let checked = event.target.checked;
            if (checked) {
                this.set_meta('yes');
            } else {
                this.set_meta('no');
            }
        },
        get_meta: function () {
            let url = Spark.api_url + '/v1/user/get_meta/notify_link_used?default=yes';
            axios.get(url)
                .then(response => {
                    //console.log(response.data);
                    if (response.data) {
                        if (response.data.notify_link_used) {
                            this.notifyme = response.data.notify_link_used == 'yes';
                        }
                    }
                })
                .catch(function (thrown) {
                    if (axios.isCancel(thrown)) {
                    } else {
                        console.log(thrown)
                    }
                });
        },
        set_meta: function (value) {
            let url = Spark.api_url + '/v1/user/set_meta';
            let params = { meta: 'notify_link_used', value: value };
            axios.post(url, params)
                .then(response => {
                    //console.log(response.data);
                    this.notifyme = value == 'yes';
                })
                .catch(function (thrown) {
                    if (axios.isCancel(thrown)) {
                    } else {
                        console.log(thrown)
                    }
                });
        }
    },

    watch: {
        email(value) {
            // binding this to the data value in the email input
            this.email = value;
            if (this.validateEmail(value) || !this.validateNotempty(value)) {
                this.emailValidOrEmpty = true;
                this.data = { o: this.userid };
                if (this.validateEmail(value)) {
                    this.data = { o: this.userid, email: value };
                }
                this.baseurl = this.custom_url + btoa(JSON.stringify(this.data));
            } else {
                this.baseurl = this.custom_url + btoa(JSON.stringify({ o: this.userid }));
                this.emailValidOrEmpty = false;
            }
        }
    },

}

</script>

<style>
/* .mosha__toast__progress {
    background: rgb(126,126,126);
}
.mosha__toast__content__text {
    padding-left: 8px;
}
.mosha__toast__content__text,
.mosha__toast__close-icon::before {
    color: rgb(97,97,97);
} */
</style>
